import {UIMDeviceHandler} from '../UIMDeviceHandler'
import {UIMSceneController} from '../UIMSceneController'
import {UIMBodyController} from './body/UIMBodyController'
import {UIMHeaderController} from './header/UIMHeaderController'
import {UIMNavigationController} from './navigation/UIMNavigationController'
import {ViewPopup} from '../../../../shared/scripts/ui_popup/ViewPopup'
import {UIDeviceController} from '../../../../shared/scripts/ui_html/UIDeviceController.ts'
import {UIUtilsEjsVariables} from '../../../../shared/scripts/UIUtilsEjsVariables.ts'
import {UIMCoinsController} from '../../ui_coins/UIMCoinsController'

export class UIMMainPageController {
    readonly headerController: UIMHeaderController
    readonly bodyController: UIMBodyController
    readonly navigationController: UIMNavigationController

    readonly sceneController: UIMSceneController

    constructor(sceneController: UIMSceneController) {
        this.sceneController = sceneController
        this.headerController = new UIMHeaderController()
        this.navigationController = new UIMNavigationController(sceneController)
        this.bodyController = new UIMBodyController(sceneController, this)
        new UIMCoinsController(sceneController)
        this.showUpdateAppPopup()
    }

    // eslint-disable-next-line class-methods-use-this
    private showUpdateAppPopup() {
        const currentBuild = UIMDeviceHandler.getBuildNumber()
        const latestBuildVersion = UIUtilsEjsVariables.showUpdateAppPopupForVersion
        if(currentBuild == null) return
        if(currentBuild > latestBuildVersion) return

        const popup = new ViewPopup({key: 'strings:homePage.popups.updateAvailable.title'},
            {key: 'strings:homePage.popups.updateAvailable.body'},
            () => this.openStoreURL(),
            () => undefined,
            true,
            {
                showXButton: false,
                showCheckButton: true,
                showXonHeader: true,
                checkButtonCustomContent: {key: 'strings:colonistCommon.utils.#buffer', options: {value: 'Update'}},
            })
        popup.show()
    }

    // eslint-disable-next-line class-methods-use-this
    private openStoreURL() {
        const playStoreLink = 'https://play.google.com/store/apps/details?id=com.colonist.colonist&pcampaignid=web_share'
        const appStoreLink = 'https://apps.apple.com/us/app/colonist-io/id6444831129'

        const storeURL = UIDeviceController.isUserOnIOSApp() ? appStoreLink : playStoreLink

        const link = document.createElement('a')
        link.href = storeURL
        link.target = '_blank'
        link.style.display = 'none'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        return
    }
}
